import React, { useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const TransportistaCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    NOMBRE: "",
    APELLIDOS: "",
    COD: "",
    DNI: "",
    TELEFONO: "",
    ES_EXTERNO: false,
    OBSERVACIONES: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // TODO: Llamar a endpoint de crear cuando esté disponible
    navigate('/transportistas');
  };

  return (
    <Card className="mt-4">
      <Card.Header>
        <h4>Nuevo transportista</h4>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Label>Nombre</Form.Label>
              <Form.Control name="NOMBRE" value={form.NOMBRE} onChange={handleChange} required />
            </div>
            <div className="col-md-6">
              <Form.Label>Apellidos</Form.Label>
              <Form.Control name="APELLIDOS" value={form.APELLIDOS} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <Form.Label>Código</Form.Label>
              <Form.Control name="COD" value={form.COD} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <Form.Label>DNI</Form.Label>
              <Form.Control name="DNI" value={form.DNI} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control name="TELEFONO" value={form.TELEFONO} onChange={handleChange} />
            </div>
            <div className="col-md-6 d-flex align-items-end">
              <Form.Check
                type="checkbox"
                label="Es externo"
                name="ES_EXTERNO"
                checked={form.ES_EXTERNO}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-12">
              <Form.Label>Observaciones</Form.Label>
              <Form.Control as="textarea" rows={3} name="OBSERVACIONES" value={form.OBSERVACIONES} onChange={handleChange} />
            </div>
          </div>
          <div className="d-flex gap-2 mt-3">
            <Button type="submit" variant="primary">Guardar</Button>
            <Button variant="secondary" onClick={() => navigate('/transportistas')}>Cancelar</Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default TransportistaCreate;


